import { useCallback } from 'react'
import { Icon } from '@calendly/ui/components/icon'
import styled from 'astroturf/react'
import { TagText, DeleteTagButton } from '@calendly/tags'
const textColorSecondary4 = 'var(--text-color-secondary-4, rgba(255, 255, 255, 1))'

import { isEnterKey, isSpaceKey } from 'services/keycodes'
import { useI18n } from 'locales'
import _StyledTagText from "normal_view-StyledTagText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/fields/guest/tag/normal_view.js?styleId=StyledTagText";
import _StyledDeleteTagButton from "normal_view-StyledDeleteTagButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/fields/guest/tag/normal_view.js?styleId=StyledDeleteTagButton";


const StyledTagText = /*#__PURE__*/styled(TagText, null, {
  displayName: "StyledTagText",
  styles: _StyledTagText
})

const StyledDeleteTagButton = /*#__PURE__*/styled(DeleteTagButton, null, {
  displayName: "StyledDeleteTagButton",
  styles: _StyledDeleteTagButton
})

const NormalView = ({
  name,
  onDelete,
  toggleView,
  isInvalid
}) => {
  const { i18n } = useI18n()
  const handleKeyDown = useCallback((handler) => (event) => {
    if (isEnterKey(event) || isSpaceKey(event)) {
      handler()
      event.preventDefault()
    }
  }, [])

  const handleMouseDown = useCallback((event) => {
    toggleView()
    event.preventDefault()
    event.stopPropagation()
  }, [toggleView])

  return (
    <>
      <StyledTagText
        // This has to be a div to be able to receive focus in Safari by Tab keypress or click
        // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
        // https://bugs.webkit.org/show_bug.cgi?id=22261
        as="div"
        role="button"
        tabIndex={0}
        isInvalid={isInvalid}
        onClick={handleMouseDown}
        onKeyDown={handleKeyDown(toggleView)}
      >
        {name}
      </StyledTagText>
      <StyledDeleteTagButton
        aria-label={i18n.t('action.remove')}
        // Same as above ^
        as="div"
        role="button"
        tabIndex={0}
        isInvalid={isInvalid}
        onClick={onDelete}
        onKeyDown={handleKeyDown(onDelete)}
      >
        <Icon name="close" />
      </StyledDeleteTagButton>
    </>
  )
}

export default NormalView
